/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://c55j6iqsljh5zdpe2at6bhwlue.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "transREST",
            "endpoint": "https://ag0tpzozvk.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "zapierREST",
            "endpoint": "https://iw6w5wtmd0.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:589ab7b6-68ee-4a02-b449-fe9590ac14a7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_pNaPHfDAh",
    "aws_user_pools_web_client_id": "5ca96dt9lhf18ep303kgfs15h",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "transloads223545-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "transMap-prod": {
                        "style": "VectorEsriStreets"
                    },
                    "transMapSatellite-prod": {
                        "style": "HybridHereExploreSatellite"
                    }
                },
                "default": "transMap-prod"
            },
            "search_indices": {
                "items": [
                    "transPlaceIndex-prod"
                ],
                "default": "transPlaceIndex-prod"
            }
        }
    }
};


export default awsmobile;
